import { IconButton, Tooltip } from '@mui/material';
import React from 'react';

import { ActionButtonProps } from './types';

export const ActionButton = ({
  disabled = false,
  onClick,
  Icon,
  tooltip,
}: ActionButtonProps) => {
  return (
    <Tooltip title={tooltip} placement="top">
      <span>
        <IconButton
          data-testid={`action-${String(tooltip).toLowerCase().replace(/\s+/g, '-')}`}
          disabled={disabled}
          onClick={onClick}
          size="small"
          sx={{ opacity: disabled ? 0.8 : 1, padding: 0 }}
        >
          <Icon />
        </IconButton>
      </span>
    </Tooltip>
  );
};
